import { render, staticRenderFns } from "./OrderAnalytics.vue?vue&type=template&id=cf19befe&"
import script from "./OrderAnalytics.vue?vue&type=script&lang=js&"
export * from "./OrderAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports